import React, {FC} from "react";
import {Customer} from "../../models";
import {decodeCurrencyPrefix} from "../../utils/currency";

export interface InputProps {
    customer?: Customer|null;
    prefix?: string;
}

const CurrencyPrefix: FC<InputProps> = (props) => {
    const {customer, prefix} = props;
    // Prefixes are stored as HTML entities (e.g. "R&nbsp;", "&#8358;&nbsp;").
    // Decode to real glyphs, then render as a text child — React escapes on
    // output, so this shows the currency symbol without an XSS-prone HTML sink.
    const resolved = decodeCurrencyPrefix(prefix ?? customer?.company?.currencyPrefix);
    return (
        (resolved && <span className={'transaction-currency-prefix'}>{resolved}</span>)
        || null
    )
};

export default CurrencyPrefix;
